import {Component, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {SearchFilterService} from '../../service/search/search-filter.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SearchbarComponent {

  filteredOptions: Observable<string[]>;

  constructor(private searchFilterService: SearchFilterService, private router: Router) {
  }

  public applySearch(event: Event) {
    const searchValue = (event.target as HTMLInputElement).value;
    this.searchFilterService.filter(searchValue, this.router.url);
  }

}
